import { createFileRoute } from '@tanstack/react-router';
import { CircleCheck } from 'lucide-react';

import { SurveyStatusContent } from '../@components/StatusContent';

export const Route = createFileRoute(
  '/_layout/$lang/quality-survey/_layout/already-submitted',
)({
  component: AlreadySubmitted,
});

function AlreadySubmitted() {
  return (
    <SurveyStatusContent
      icon={CircleCheck}
      iconBgClassName="bg-emerald-50"
      iconClassName="text-emerald-500"
      messageKey="survey.already_submitted.message"
      titleKey="survey.already_submitted.title"
    />
  );
}
